import { useGetDefaultPage } from '@/api/websiteApi';
import { BackToTopButton } from '@/components/animate';
import { LoadingScreen } from '@/components/loading-screen';
import { SectionsComponents } from '@/page-sections/sections';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type PropTypes = {
  uri: string;
};

const DefaultPage = ({ uri }: PropTypes) => {
  const { data, loading } = useGetDefaultPage(uri);
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  if (loading) {
    return <LoadingScreen color="primary" />;
  }

  return (
    <>
      <BackToTopButton />

      {data?.sections?.map((field) => {
        const componentName = field.fieldGroupName;

        if (!componentName || !SectionsComponents[componentName]) {
          return null;
        }

        const SectionComponent = SectionsComponents[componentName];
        return <SectionComponent key={`${componentName}-${field.uniqueId}`} section={field} />;
      })}
    </>
  );
};

export default DefaultPage;
